module.exports = __webpack_public_path__ + "img/somalia.b6907d05.svg";